module.exports = __webpack_public_path__ + "img/all_partner_logo.aeb4592.png";